import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import CartDrawer from './components/cart/CartDrawer';
import ProductQuickView from './components/product/ProductQuickView';
import { ShopProvider } from './context/ShopContext';
import { initPostHog, trackPageView } from './lib/posthog';

// Pages
import Home from './pages/Home';
import CategoryPage from './pages/CategoryPage';
import ProductPage from './pages/ProductPage';
import ArticlePage from './pages/ArticlePage';
import { AboutPage, ContactPage, CustomerServicePage } from './pages/StaticPages';
import NotFound from './pages/NotFound';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import CookieConsent from './components/layout/CookieConsent';

// Initialize PostHog
initPostHog();

// Track page views + scroll to top on route change
const RouteTracker = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(pathname);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <ShopProvider>
      <Router>
        <RouteTracker />
        <Routes>
          {/* Admin routes — no navbar/footer */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />

          {/* Store routes — with navbar/footer */}
          <Route
            path="*"
            element={
              <div className="min-h-screen flex flex-col bg-background font-sans selection:bg-primary/20">
                <Navbar />
                <main className="flex-grow">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/category/:slug" element={<CategoryPage />} />
                    <Route path="/product/:id" element={<ProductPage />} />
                    <Route path="/article/:id" element={<ArticlePage />} />
                    <Route path="/om-oss" element={<AboutPage />} />
                    <Route path="/kontakt" element={<ContactPage />} />
                    <Route path="/kundeservice" element={<CustomerServicePage />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </main>
                <Footer />
                <CartDrawer />
                <ProductQuickView />
                <CookieConsent />
              </div>
            }
          />
        </Routes>
      </Router>
    </ShopProvider>
  );
}

export default App;
